/**
 * @file Writes a served period's bounds as ISO dates in the calendar time
 * zone, such as `"2026-01-01 → 2026-08-06"`. Consumer: the Metrics tab's Date
 * Range, on its selected option only, since no other option was served. The
 * served `to` is the exclusive instant the query ran at, so read in the
 * calendar zone it is today's date there.
 */
import { DateTime } from 'luxon';

import type { ResolvedAnalyticsPeriod } from '#types';

export const analyticsPeriodBoundsText = (
  { from, to }: Pick<ResolvedAnalyticsPeriod, 'from' | 'to'>,
  timeZone: string,
): string =>
  [from, to]
    .map((bound) => DateTime.fromISO(bound, { zone: timeZone }).toISODate())
    .join(' → ');
